import { LoaderIcon } from 'fitify-ui/src/Icon/outline/LoaderIcon'

import { Typography } from '../../Typography'

import { StyledTextButton } from './Button.Styled'
import type { TextButtonProps } from './Button.Types'

export const TextButton = ({
  children,
  icon,
  isDisabled = false,
  isLoading = false,
  size = 'medium',
  variant = 'secondary',
  ...htmlProps
}: TextButtonProps) => {
  return (
    <StyledTextButton
      {...htmlProps}
      $isLoading={isLoading}
      $variant={variant}
      disabled={isDisabled}
    >
      {isLoading ? (
        <LoaderIcon />
      ) : (
        <>
          <Typography
            $color="inherit"
            $variant={
              size === 'small' ? 'Poppins/T3 - Medium' : 'Poppins/T2 - Medium'
            }
          >
            {children}
          </Typography>
          {icon}
        </>
      )}
    </StyledTextButton>
  )
}
